<div class="app-background">
<router-outlet></router-outlet>
  <!-- fixed image -->
  <img src="/assets/images/background.png" class="background-img1" />
</div>